import axios from "axios";
import { Cookies } from "react-cookie";
import { message } from "antd";
import { Constants } from "./settings";

const _cookies = new Cookies();

axios.defaults.headers.common["fcmToken"] = localStorage["fcmToken"]
  ? localStorage["fcmToken"]
  : "";
axios.defaults.baseURL = Constants.baseUrl;
axios.defaults.headers.common["Authorization"] = `Bearer ${
  _cookies.get("AccessToken") || ""
}`;
axios.defaults.headers.common["panel"] = "barcode";
const handleError = (error = {}) => {
  //   let data = error["data"];
  //   let status = error["status"];
  // if (status === 422) {
  //   if (Array.isArray(data.errors)) {
  //     data.errors.forEach(text => message.error(`${text}`, "خطا"));
  //   } else if (typeof data.errors == "object") {
  //     let er = [];
  //     Object.values(data.errors).forEach(e => er.push(e));
  //     message.error(`${er.join(" - ")}`, "خطا");
  //   } else {
  //     message.error(`${data.errors}`, "خطا");
  //   }
  // }else{
    switch (error.message) {
      case "Unauthenticated.":
        _cookies.remove("AccessToken", {
          path: "/",
          expires: new Date(1900, 1, 1),
          domain: window.location.hostname,
        });
        window.location = "/account/login";
        break;
      default:
        if (Array.isArray(error.message))
          error.message.forEach((text) => message.error(text));
        else if (error.message) message.error(error.message);
        break;
    }
  // }


};

const upload = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, { headers: { "content-type": "multipart/form-data" } })
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const get = (url) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        if (response && response.data) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const downloadFile = (url) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { 
        responseType: 'blob'// <=== you need this one
      })
      .then((response) => {
        if (response && response.data) {
          window.open(URL.createObjectURL(response.data))
          // resolve(response.data);
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};
const post = (url, params = {}, skip) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((response) => {
        if (response && response.data) {
          if (skip || response.data.status === 1) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const put = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const del = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, params)
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

export default {
  brand: {
    add: (params = {}) => {
      return post(`brand/store`, params);
    },
    delete: (id) => {
      return del(`brand/${id}/destroy`);
    },
    list: () => {
      return get("brand");
    },
    statusUpdate: (params = {}) => {
      return post(
        `brand/${params.id}/statusUpdate?status=${!!params.status ? 0 : 1}`
      );
    },
    update: (params, id) => {
      return post(`brand/${id}/update`, params);
    },
  },
  category: {
    add: (params = {}) => {
      return upload(`category/store`, params);
    },
    list: (params = {}) => {
      let src = `category?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.type) src = `${src}&type=${params.type}`;

      if (params.parentId) src = `${src}&parentId=${params.parentId}`;

      return get(src);
    },
    statusUpdate: (params = {}) => {
      return put(
        `category/${params.id}/statusUpdate?status=${
          !!parseInt(params.status) ? 0 : 1
        }`
      );
    },
    delete: (params = {}) => {
      return del(`category/${params.id}/destroy`);
    },
    update: (params, id) => {
      return upload(`category/${id}/update`, params);
    },
  },
  bank: {
    add: (params = {}) => {
      return upload(`bank/store`, params);
    },
    list: (params = {}) => {
      let src = `bank?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      return get(src);
    },

    delete: (params = {}) => {
      return del(`bank/${params.id}/destroy`);
    },
    update: (params, id) => {
      return upload(`bank/${id}/update`, params);
    },
  },
  dashboard: {
    list: () => {
      return get("dashboard");
    },
  },
  message: {
    add: (params = {}) => {
      return post(`message/store`, params);
    },
    addDraft: (params = {}) => {
      return post(`draft/store`, params);
    },
    list: (params = {}) => {
      let src = `message?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    delete: (id) => {
      return del(`message/${id}/destroy`);
    },
    deleteDraft: (id) => {
      return del(`draft/${id}/destroy`);
    },
    draftList: (params = {}) => {
      let src = `draft?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    updateDraft: (params, id) => {
      return post(`draft/${id}/update`, params);
    },
  },
  offer: {
    add: (params = {}) => {
      return post(`special/store`, params);
    },
    list: (params = {}) => {
      let src = `special?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      return get(src);
    },
    statusUpdate: (params = {}) => {
      return post(
        `special/${params.id}/updateStatus?status=${
          !!parseInt(params.status) ? 0 : 1
        }`
      );
    },
    delete: (params = {}) => {
      return del(`special/${params.id}/destroy`);
    },
    update: (params, id) => {
      return post(`special/${id}/update`, params);
    },
  },
  order: {
    add: (params = {}) => {
      return post(`cart/store`, params);
    },
    delete: (id) => {
      return del(`cart/${id}/destroy`);
    },

    getExcelOrder: (id) => {
      return get(`cart/${id}/getExcelOrder`);
    },
    getOrder: (id) => {
      return get(`cart/${id}/getOrder`);
    },
    list: (params = {}) => {
      let src = `cart?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      if (params.orderType) src = `${src}&orderType=${params.orderType}`;

      if (params.payStatus) src = `${src}&paymentStatus=${params.payStatus}`;

      if (params.payType) src = `${src}&paymentType=${params.payType}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;

      if (params.status) src = `${src}&status=${params.status}`;
      if (params.isSuspend) src = `${src}&isSuspend=${params.isSuspend}`;
      if (params.bazara_id) src = `${src}&bazara_id=${params.bazara_id}`;

      return get(src);
    },
    update: (params, id) => {
      return post(`cart/${id}/update`, params);
    },

    sendToAccounting: (id) => {
      return post(`cart/${id}/sendToAccounting`);
    },
  },
  remittance: {

    list: (params = {}) => {
      let src = `remittance/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      if (params.endDate) src = `${src}&endDate=${params.endDate}`;

      if (params.startDate) src = `${src}&startDate=${params.startDate}`;


      return get(src);
    },

  },
  postman: {
    list: () => {
      return get("postman/getLocation");
    },
    report: (params = {}) => {
      return get(
        `postman/${params.id}/predictedDistance?fromDate=${params.fromDate}&toDate=${params.toDate}`
      );
    },
  },
  product: {
    addImage: (params = {}) => {
      return upload(`product/images/store`, params);
    },
    list: (params = {}) => {
      let src = `barcodePanel/product/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.pageSize) src = `${src}&per_page=${params.pageSize}`;

      if (params.image) src = `${src}&image=${params.image}`;

      if (params.category) src = `${src}&category=${params.category}`;

      if (params.code) src = `${src}&code=${params.code}`;

      if (params.isVip) src = `${src}&isVip=${params.isVip}`;

      if (params.categoryId) src = `${src}&category_id=${params.categoryId}`;

      if (params.products_without_price) src = `${src}&products_without_price=${params.products_without_price}`;

      if (params.with_count) src = `${src}&with_count=${params.with_count}`;

      
      if (params.subCategoryId)
        src = `${src}&subCategory_id=${params.subCategoryId}`;

      return get(src);
    },
    statusUpdate: (params = {}) => {
      return post(
        `product/${params.id}/StatusUpdate?status=${
          !!parseInt(params.status) ? 0 : 1
        }`
      );
    },

    vipUpdate: (params = {}) => {
      return post(
        `product/${params.id}/VipUpdate?isVip=${
          !!parseInt(params.isVip) ? 0 : 1
        }`
      );
    },
    deleteImage: (id = {}) => {
      return del(`product/images/${id}/destroy`);
    },
    update: (params, id) => {
      return upload(`barcodePanel/product/update/${id}`, params);
    },
    save: (params) => {
      return upload(`product/save`, params);
    },
    excelUpload: (params = {}) => {
      return post(`/exel`, params);
    },
  },
  question: {
    add: (params = {}) => {
      return post(`question/store`, params);
    },
    delete: (id) => {
      return del(`question/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `question?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    update: (params, id) => {
      return post(`question/${id}/update`, params);
    },
  },
  setting: {
    list: () => {
      return get("setting");
    },
    update: (params) => {
      return upload(`setting/update`, params);
    },
  },
  slider: {
    add: (params = {}) => {
      return post(`slider/store`, params);
    },
    delete: (id) => {
      return del(`slider/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `slider?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    statusUpdate: (params = {}) => {
      return post(
        `slider/${params.id}/statusUpdate?status=${!!params.status ? 0 : 1}`
      );
    },
    update: (params, id) => {
      return post(`slider/${id}/update`, params);
    },
  },
  tag: {
    add: (params = {}) => {
      return post(`tag/store`, params);
    },
    delete: (id) => {
      return del(`tag/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `tag?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
    update: (params, id) => {
      return post(`tag/${id}/update`, params);
    },
  },
  user: {
    add: (params = {}) => {
      return post(`barcodePanel/barcodeUser/store`, params);
    },
    delete: (params = {}) => {
      return del(`user/${params.id}/destroy`);
    },
    details: (id) => {
      return get(`user/${id}`);
    },
    list: (params = {}) => {
      let src = `barcodePanel/barcodeUser/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.user_type) src = `${src}&user_type=${params.user_type}`;

      if (params.level && params.level.length)
        params.level.forEach((o) => {
          src = `${src}&operator_level[]=${o}`;
        });

      return get(src);
    },
    me: () => {
      return get("barcodePanel/auth/me");
    },
    update: (params, id) => {
      return put(`barcodePanel/barcodeUser/${id}/update`, params);
    },
    increaseCredit: (params = {}) => {
      return post(`user/${params.id}/chargeAccount`, params);
    },
    decreaseCredit: (params = {}) => {
      return post(`user/${params.id}/removalAccount`, params);
    },
    permissionUpdate: (params = {}) => {
      return post(`user/${params.id}/permissionUpdate`, params);
    },
    statusUpdate: (params = {}) => {
      return put(
        `user/${params.id}/StatusUpdate?status=${
          !!parseInt(params.status) ? 0 : 1
        }`
      );
    },
    vipUpdate: (params = {}) => {
      return put(
        `user/${params.id}/VipUpdate?isVip=${!!parseInt(params.isVip) ? 0 : 1}`
      );
    },
    login: (params = {}) => {
      return post("auth/login", params, true);
    },
    verify: (params = {}) => {
      return post("auth/verify", params, true);
    },
  },
  voip: {
    distance: (params = {}) => {
      return post("location/getDistance", params);
    },
    user: (params = {}) => {
      return get(`voip/search?phone=${params.phone}`);
    },
    products: (params = {}) => {
      return post("voip/search/product", params);
    },

    deleteBarcodes: (params = {}) => {
      return post("voip/delete/barcodes", params);
    },
  },
  downloadApp: {
    list: () => {
      return get("downloadApp/list");
    },
    add: (params = {}) => {
      return post("downloadApp/save", params);
    },
    update: (params = {}) => {
      return post("downloadApp/update", params);
    },
    detail: {
      list: () => {
        return get("downloadApp/detail/list");
      },
      save: (params = {}) => {
        return post("downloadApp/detail/save", params);
      },
    },
  },
  // new apis for barcode products

  tempOrder: {
    add: (params = {}) => {
      return post(`barcodePanel/tempOrder/store`, params);
    },
    delete: (id) => {
      return del(`barcodePanel/tempOrder/destroy`);
    },
    list: (params = {}) => {
      let src = `barcodePanel/tempOrder/list?phone=${params.phone}`;
      return get(src);
    },

   
  },

  countType: {
    add: (params = {}) => {
      return post(`barcodePanel/countType/store`, params);
    },
    delete: (id) => {
      return del(`barcodePanel/countType/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `barcodePanel/countType/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },

    update: (params, id) => {
      return post(`barcodePanel/countType/${id}/update`, params);
    },
  },

  shelf: {
    add: (params = {}) => {
      return post(`barcodePanel/shelf/store`, params);
    },
    delete: (id) => {
      return del(`barcodePanel/shelf/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `barcodePanel/shelf/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.total) src = `${src}&total=${params.total}`;

      return get(src);
    },

    update: (params, id) => {
      return post(`barcodePanel/shelf/${id}/update`, params);
    },
  },
  productRow: {
    add: (params = {}) => {
      return post(`barcodePanel/productRow/store`, params);
    },
    delete: (id) => {
      return del(`barcodePanel/productRow/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `barcodePanel/productRow/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.total) src = `${src}&total=${params.total}`;

      return get(src);
    },

    update: (params, id) => {
      return post(`barcodePanel/productRow/${id}/update`, params);
    },
  },
  printSize: {
    add: (params = {}) => {
      return post(`barcodePanel/printSize/store`, params);
    },
    delete: (id) => {
      return del(`barcodePanel/printSize/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `barcodePanel/printSize/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },

    update: (params, id) => {
      return post(`barcodePanel/printSize/${id}/update`, params);
    },
  },
  productIdentifier: {
    add: (params = {}) => {
      return post(`barcodePanel/productIdentifier/store`, params);
    },
    delete: (id) => {
      return del(`barcodePanel/productIdentifier/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `barcodePanel/productIdentifier/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.total) src = `${src}&total=${params.total}`;

      return get(src);
    },

    update: (params, id) => {
      return post(`barcodePanel/productIdentifier/${id}/update`, params);
    },
  },
  printBarcode: {
    add: (params = {}) => {
      return post(`barcodePanel/printBarcode/store`, params);
    },
    delete: (id) => {
      return del(`barcodePanel/printBarcode/${id}/destroy`);
    },
    list: (params = {}) => {
      let src = `barcodePanel/printBarcode/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.startDate) src = `${src}&startDate=${params.startDate}`;
      if (params.endDate) src = `${src}&endDate=${params.endDate}`;


      return get(src);
    },

    update: (params, id) => {
      return post(`barcodePanel/printBarcode/${id}/update`, params);
    },

    getDeletedBarcodes: (id = {}) => {
      let src = `barcodePanel/printBarcode/getDeletedBarcodes/${id}`;

      return get(src);
    },
    getPrintBarcodesDetail: (id = {}) => {
      let src = `barcodePanel/printBarcode/${id}/printedBarcodesDetail`;

      return get(src);
    },

    productBarcodes: (id = {}) => {
      let src = `barcodePanel/printBarcode/product/list/${id}`;

      return get(src);
    },

    productOutBarcodes: (id = {}, params= {}) => {
      let src = `barcodePanel/printBarcode/product/out/list/${id}?`;
      if (params.page) src = `${src}&page=${params.page}`;
      if (params.barcode) src = `${src}&barcode=${params.barcode}`;
      if (params.package_count) src = `${src}&package_count=${params.package_count}`;
      return get(src);
    },

    deleteItemBarcode: (id, params) => {
      return post(`barcodePanel/printBarcode/barcode/delete/${id}`, params);
    },

    restoreItemBarcode: (id) => {
      return get(`barcodePanel/printBarcode/barcode/restore/${id}`);
    },
  },


  productPackage: {

    list: (params = {}) => {
      let src = `barcodePanel/package/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },


  },
  userBarcodePanel: {

    list: (params = {}) => {
      let src = `barcodePanel/user/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;

      return get(src);
    },
  },

    BarcodeReports: {

        list: (params = {}) => {
            return post(`barcodePanel/report/list`, params);
        },
      productUsedBarcodes: (id, params = {}) => {
        return post(`barcodePanel/report/productUsedBarcodes/${id}`, params);
      },


      delete: (id) => {
        return del(`barcodePanel/report/${id}/destroy`);
      },
    },

    circular_goods: {

        list: (params = {}) => {
            return post(`barcodePanel/circular_goods/list`, params);
        },
        brarcodesListBySelectedGroup: (params = {}) => {
          return post(`barcodePanel/circular_goods/brarcodesListBySelectedGroup`, params);
      },
    },
    circular_goods_products: {

        list: (params = {}) => {
            return post(`barcodePanel/circular_goods_products/list`, params);
        },
         excelExport: (params = {}) => {
            return post(`barcodePanel/circular_goods_products/export/excel`, params);
        },

         excelExport: (params = {}) => {
          let src = `barcodePanel/circular_goods_products/export/excel?q=${params.q || ""}`;

          if (params.endDate) src = `${src}&endDate=${params.endDate}`;
           if (params.startDate) src = `${src}&startDate=${params.startDate}`;

          return get(src);
        },
        brarcodesListBySelectedGroup: (params = {}) => {
          return post(`barcodePanel/circular_goods_products/brarcodesListBySelectedGroup`, params);
      },
    },

};
